// Mock agent runs (history + active)
export const mockAgentRuns = [
  {
    id: "run_001",
    project_id: "proj_codex_skills",
    title: "Top 10 Codex Skills - LinkedIn + X + Shorts",
    status: "completed",
    started_at: "2026-01-22T13:42:00Z",
    finished_at: "2026-01-22T13:48:00Z",
    model: "anthropic",
    platforms: ["linkedin", "x", "youtube_shorts"],
    skills_used: ["LinkedInAuthorityPost", "XThreadBuilder", "YouTubeShortsHook", "AdamVoice", "ResearchNotes"],
    asset_ids: ["asset_li_codex_1", "asset_x_thread_codex", "asset_yts_codex", "asset_img_codex"],
    audience: "AI founders + operators building agentic workflows",
    research_mode: "deep",
    steps: [
      { id: "s1", label: "Analyzed request", status: "done", at: "2026-01-22T13:42:10Z" },
      { id: "s2", label: "Selected skills", status: "done", at: "2026-01-22T13:42:40Z", note: "5 skills routed by phase" },
      { id: "s3", label: "Researched sources", status: "done", at: "2026-01-22T13:44:02Z", note: "7 sources, 2 cited" },
      { id: "s4", label: "Created strategy", status: "done", at: "2026-01-22T13:45:20Z" },
      { id: "s5", label: "Generated drafts", status: "done", at: "2026-01-22T13:47:00Z", note: "4 assets" },
      { id: "s6", label: "Critiqued and revised", status: "done", at: "2026-01-22T13:47:48Z" },
      { id: "s7", label: "Ready for review", status: "done", at: "2026-01-22T13:48:00Z" },
    ],
  },
  {
    id: "run_002",
    project_id: "proj_smb_content",
    title: "Repurpose: AI Content Systems for SMBs",
    status: "running",
    started_at: "2026-01-22T15:01:00Z",
    finished_at: null,
    model: "openai",
    platforms: ["linkedin", "x", "instagram"],
    skills_used: ["RepurposeContent", "AdamVoice", "SocialMediaSEO"],
    asset_ids: [],
    audience: "SMB owners + service businesses",
    research_mode: "sources_only",
    steps: [
      { id: "s1", label: "Analyzed request", status: "done", at: "2026-01-22T15:01:05Z" },
      { id: "s2", label: "Selected skills", status: "done", at: "2026-01-22T15:01:22Z" },
      { id: "s3", label: "Researched sources", status: "running", at: "2026-01-22T15:02:08Z", note: "Scanning blog + transcripts" },
      { id: "s4", label: "Created strategy", status: "pending" },
      { id: "s5", label: "Generated drafts", status: "pending" },
      { id: "s6", label: "Critiqued and revised", status: "pending" },
      { id: "s7", label: "Ready for review", status: "pending" },
    ],
  },
  {
    id: "run_003",
    project_id: "proj_hvac_voice",
    title: "HVAC voice agents - LinkedIn lead post",
    status: "completed",
    started_at: "2026-01-22T10:30:00Z",
    finished_at: "2026-01-22T10:42:00Z",
    model: "anthropic",
    platforms: ["linkedin"],
    skills_used: ["ContractorTrustBuilder", "AdamVoice", "OfferPositioning"],
    asset_ids: ["asset_hvac_li"],
    audience: "HVAC owners + service business operators",
    research_mode: "none",
    steps: [
      { id: "s1", label: "Analyzed request", status: "done", at: "2026-01-22T10:30:10Z" },
      { id: "s2", label: "Selected skills", status: "done", at: "2026-01-22T10:30:40Z" },
      { id: "s3", label: "Researched sources", status: "skipped" },
      { id: "s4", label: "Created strategy", status: "done", at: "2026-01-22T10:32:11Z" },
      { id: "s5", label: "Generated drafts", status: "done", at: "2026-01-22T10:38:00Z" },
      { id: "s6", label: "Critiqued and revised", status: "done", at: "2026-01-22T10:41:00Z" },
      { id: "s7", label: "Ready for review", status: "done", at: "2026-01-22T10:42:00Z" },
    ],
  },
  {
    id: "run_004",
    project_id: "proj_skills_thesis",
    title: "Thesis blog - outline + draft",
    status: "failed",
    started_at: "2026-01-21T22:12:00Z",
    finished_at: "2026-01-21T22:14:00Z",
    model: "openrouter",
    platforms: ["blog"],
    skills_used: ["ResearchNotes", "TechnicalExplainer"],
    asset_ids: [],
    audience: "-",
    research_mode: "deep",
    error: "Research source returned 429; retried twice. Stopping.",
    steps: [
      { id: "s1", label: "Analyzed request", status: "done", at: "2026-01-21T22:12:05Z" },
      { id: "s2", label: "Selected skills", status: "done", at: "2026-01-21T22:12:18Z" },
      { id: "s3", label: "Researched sources", status: "failed", at: "2026-01-21T22:13:50Z", note: "429 from source A" },
      { id: "s4", label: "Created strategy", status: "pending" },
      { id: "s5", label: "Generated drafts", status: "pending" },
      { id: "s6", label: "Critiqued and revised", status: "pending" },
      { id: "s7", label: "Ready for review", status: "pending" },
    ],
  },
];

export const mockResearchNotes = {
  audience: "AI founders + operators who already ship agentic systems but feel the limits of prompt tuning.",
  angle: "Skills are the missing primitive of agent design. Phase-aware routing > smarter models.",
  sources: [
    { label: "Anthropic agent design notes", domain: "anthropic.com", credibility: "high" },
    { label: "Internal the workspace skill audit (Jan 2026)", domain: "internal", credibility: "high" },
    { label: "OpenAI Operator update", domain: "openai.com", credibility: "medium" },
  ],
  risks: [
    "Avoid implying that 'skill' is the same as 'tool' - it isn't.",
    "Don't dunk on a competitor; lift the whole space.",
    "Don't promise a 10x productivity number without measurement.",
  ],
};
export const mockStrategy = {
  headline: "Reposition 'skills' from buzzword to operator primitive.",
  positioning: "the workspace ships an opinionated 5-phase skill library so a solo operator can run an agent factory.",
  cta_strategy: "Soft DM funnel: comment word -> DM -> share template/file.",
  cross_platform_logic: [
    "LinkedIn = authority post (mid-long, executive tone)",
    "X = thread w/ punchy 5-step framework",
    "Shorts = 45s hook + framework + comment-driven CTA",
  ],
};
